import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faPen } from '@fortawesome/free-solid-svg-icons';
import { getToggleActiveMenuItem } from '@/shared/utils/menuItems/getToggleActiveMenuItem';

export const getMenuItems = ({ record, actions }) => {
  const menuItems = [
    {
      label: 'Editar',
      key: 'updateAgreement',
      icon: <FontAwesomeIcon icon={faPen} />,
      onClick: actions.updateAgreement.handler,
      loading: actions.updateAgreement.loading,
    },
    {
      label: 'Ver',
      key: 'viewAgreement',
      icon: <FontAwesomeIcon icon={faEye} />,
      onClick: actions.viewAgreement.handler,
      loading: actions.viewAgreement.loading,
    },
    getToggleActiveMenuItem({
      record,
      onActivate: actions.activate.handler,
      onInactivate: actions.inactivate.handler,
      loading: actions.activate.loading || actions.inactivate.loading,
    }),
  ];

  return menuItems;
};
